import 'css-chunksrc/client/common/filterMenu/projectStatuses/styles.scss';export default {
  "header": "_header_sfc2s_1",
  "icon": "_icon_sfc2s_10",
  "title": "_title_sfc2s_18",
  "list": "_list_sfc2s_25"
};